import React from 'react';
import GoogleMapReact from 'google-map-react';
import { useDispatch } from 'react-redux';
import { getLocationByLongAndLat } from '../../Redux/Action/LocationAction';

function Maps({ setShow }) {

    const dispatch = useDispatch();

    const getCoordinates = () => {
        let obj = {};
        navigator.geolocation.getCurrentPosition(function (position) {

            obj.lat = position.coords.latitude;
            obj.lng = position.coords.longitude;

        });
        return obj;
    };

    const defaultProps = {
        center: getCoordinates(),
        zoom: 11
    };
    console.log("🚀 ~ ForecastTabs ~ defaultProps:", defaultProps);


    const handleApiLoaded = (map, maps) => {
        console.log("🚀 ~ handleApiLoaded ~ map, maps:", map, maps);
        // use map and maps objects
    };

    const onClickMap = (data) => {
        console.log("🚀 ~ onClickMap ~ data:", data);
        dispatch(getLocationByLongAndLat(data.lng, data.lat, true));
        setShow();

    };
    return (
        <div>
            <div style={{ height: '100vh', width: '100%' }}>
                {/* <GoogleMapReact
                        bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY }}
                        defaultCenter={defaultProps.center}
                        defaultZoom={defaultProps.zoom}
                    >
                       
                    </GoogleMapReact> */}
                <GoogleMapReact
                    onClick={onClickMap}
                    bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_KEY }}
                    defaultCenter={defaultProps.center}
                    defaultZoom={defaultProps.zoom}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
                >
                </GoogleMapReact>

            </div>
        </div>
    );
}

export default Maps;